import type { AppError, HandleErrorOptions } from '@/shared/model/types/error';
import { normalizeError } from '@/shared/lib/errors/normalizeError';
import { logError } from '@/shared/lib/errors/logger';
import { useNotifyStore } from '@/shared/ui/AppNotify/store';

export const useErrorHandler = () => {
  const handleError = (error: unknown, options: HandleErrorOptions = {}): AppError => {
    const { notify = false, notifyUnlessFields, message, context } = options;

    const appError = normalizeError(error);

    logError(appError, context);

    const finalError = message ? { ...appError, message } : appError;

    const hasFields = Object.keys(finalError.fields).length > 0;
    const toastText = notifyUnlessFields && !hasFields ? notifyUnlessFields : null;

    if (toastText || notify) {
      useNotifyStore().showNotify({
        title: toastText ?? finalError.message,
        type: 'error',
      });
    }

    return finalError;
  };

  return { handleError };
};
